import { StyleAgentConfig } from '../types';
import { SYSTEM_AGENTS } from '../constants';
import { getUserProfile, saveUserProfile } from '@shared/services/userService';

const DEACTIVATED_SYSTEM_AGENTS_KEY = 'deactivated_system_agents';

export const getDeactivatedSystemAgentIds = (): string[] => {
    try {
        const data = localStorage.getItem(DEACTIVATED_SYSTEM_AGENTS_KEY);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        console.error('Failed to load deactivated system agents', e);
        return [];
    }
};

export const saveDeactivatedSystemAgentIds = (ids: string[]): void => {
    try {
        localStorage.setItem(DEACTIVATED_SYSTEM_AGENTS_KEY, JSON.stringify(ids));
    } catch (e) {
        console.error('Failed to save deactivated system agents', e);
    }
};

export const deactivateSystemAgent = (agentId: string): void => {
    const ids = getDeactivatedSystemAgentIds();
    if (!ids.includes(agentId)) {
        saveDeactivatedSystemAgentIds([...ids, agentId]);
    }
};

export const activateSystemAgent = (agentId: string): void => {
    const ids = getDeactivatedSystemAgentIds();
    saveDeactivatedSystemAgentIds(ids.filter(id => id !== agentId));
};

export const isSystemAgentActive = (agentId: string): boolean => {
    const deactivatedIds = getDeactivatedSystemAgentIds();
    return !deactivatedIds.includes(agentId);
};

export const toggleSystemAgent = (agentId: string): void => {
    if (isSystemAgentActive(agentId)) {
        deactivateSystemAgent(agentId);
    } else {
        activateSystemAgent(agentId);
    }
};

export const deactivateUserAgent = (userId: string, agentId: string): void => {
    const profile = getUserProfile(userId);
    if (profile.styleAgents) {
        profile.styleAgents = profile.styleAgents.map(a =>
            a.id === agentId ? { ...a, isActive: false } : a
        );
        saveUserProfile(userId, profile);
    }
};

export const activateUserAgent = (userId: string, agentId: string): void => {
    const profile = getUserProfile(userId);
    if (profile.styleAgents) {
        profile.styleAgents = profile.styleAgents.map(a =>
            a.id === agentId ? { ...a, isActive: true } : a
        );
        saveUserProfile(userId, profile);
    }
};

export const toggleUserAgent = (userId: string, agentId: string): void => {
    const profile = getUserProfile(userId);
    const agent = profile.styleAgents?.find(a => a.id === agentId);
    if (agent) {
        if (agent.isActive) {
            deactivateUserAgent(userId, agentId);
        } else {
            activateUserAgent(userId, agentId);
        }
    }
};
